import { render, staticRenderFns } from "./JournalsFilter.vue?vue&type=template&id=6a7db0f6&scoped=true"
import script from "./JournalsFilter.vue?vue&type=script&lang=js"
export * from "./JournalsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7db0f6",
  null
  
)

export default component.exports